/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-useless-escape */
import i18n from 'i18n';
import { regexExp } from 'utils/helpers';
import * as Yup from 'yup';

const schema = {
  first_name: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .matches(regexExp.lettersOnly, i18n.t('ONLY_LETTERS_KEY')),
  last_name: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .matches(regexExp.lettersOnly, i18n.t('ONLY_LETTERS_KEY')),
  email: Yup.string()
    .email(i18n.t('EMAIL_INVALID_KEY'))
    .required(i18n.t('REQUIRED_FIELD_KEY')),
  language: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  role: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  company: Yup.object().shape({
    company_uuid: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  }),
};

export default {
  create: Yup.object().shape({
    ...schema,
  }),
  edit: Yup.object().shape(schema),
  reset: Yup.object().shape({
    current_password: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    password: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    password_confirmation: Yup.string()
      .oneOf([Yup.ref('password'), null], i18n.t('PASSWORD_NOT_MATCH_KEY'))
      .required(i18n.t('REQUIRED_FIELD_KEY')),
  }),
};
